import Image from 'next/image'
import {FC} from 'react'

import {Button} from '@/components/common/content/Button'
import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {Text, TextVariant} from '@/components/common/content/Text'
import {getBlogContent} from '@/content/blog/blog'
import {Link, useTranslation} from '@/i18n'
import {BLOG_CONTENT_WIDTH} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {Industry} from '@/utils/contentful'
import {routeTo} from '@/utils/router'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type BlogNavigationProps = {
  industry: Industry
}

export const BlogNavigation: FC<React.PropsWithChildren<BlogNavigationProps>> = ({
  industry: {name, heroImage},
}) => {
  const {t} = useTranslation()

  const {navigationTitle, navigationButtonText} = getBlogContent()
  const link = name === 'general' ? routeTo.blog.home() : routeTo.blog.industry(name)

  return (
    <>
      <div className="wrapper">
        <div className="content">
          <Text variant={TextVariant.h4} element="h2">
            {t(navigationTitle)}
          </Text>
          <div className="button-wrapper">
            <Link href={link}>
              <Button variant={ButtonVariant.primary} type="button">
                {t(navigationButtonText)}
              </Button>
            </Link>
          </div>
        </div>
        <div className="image">
          <Image
            src={heroImage.url}
            alt={heroImage.alt}
            style={{objectFit: 'cover'}}
            width={180}
            height={200}
          />
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          align-items: center;
          max-width: ${BLOG_CONTENT_WIDTH};
          margin: 0 auto;
        }

        .button-wrapper {
          margin-top: ${theme.spacing[5]};
        }

        .image {
          position: relative;
          width: 180px;
          height: 200px;
          margin-left: ${theme.spacing[9]};
        }

        @media ${TABLET_SCREENSIZE} {
          .image {
            margin-left: ${theme.spacing[6]};
          }
        }

        @media ${MOBILE_SCREENSIZE} {
          .wrapper {
            display: block;
            text-align: center;
          }

          .image {
            display: none;
          }

          .button-wrapper {
            margin-top: ${theme.spacing[4]};
          }
        }
      `}</style>
    </>
  )
}
